export default __webpack_public_path__ + "img/img_shaf-4c12be2773221c392dab0bdd18bc6237.jpg";